import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {observer, inject} from 'mobx-react'
import Sidebar from 'react-sidebar'
import {toJS} from 'mobx'
import {Row, Col, Button, Glyphicon} from 'react-bootstrap'
import {Link, browserHistory} from 'react-router'
import Confirm from 'react-confirm-bootstrap'
import Logger from '../stores/Logger'
import BrowserDetection from 'react-browser-detection'
import ToolTip from '../components/ToolTip.js'
import './css/Sidebar.css'
import { majorModes } from './Header'

const mql = window.matchMedia(`(min-width: 800px)`) //TODO: is 800 the right number?

class IdeaPageSidebar extends Component {

    constructor(props) {
        super(props)
        this.state = {
            mql: mql,
            docked: props.docked,
            open: props.open,
            adjustmentNumber: null,
        }
        this.mediaQueryChanged = this.mediaQueryChanged.bind(this)
        this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this)
        this.doHideSidebar = this.doHideSidebar.bind(this)
        this.toggleOpen = this.toggleOpen.bind(this)
        this.handleDuplicate = this.handleDuplicate.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.onPresentOptions = this.onPresentOptions.bind(this)
        this.onViewIdea = this.onViewIdea.bind(this)
        this.onEditIdea = this.onEditIdea.bind(this)
        this.openTab = this.openTab.bind(this)
        this.onresize = this.onresize.bind(this)
        this.checkForDescContent = this.checkForDescContent.bind(this)
        this.checkForDetailsContent = this.checkForDetailsContent.bind(this)
        this.checkForStage = this.checkForStage.bind(this)
        this.checkForRec = this.checkForRec.bind(this)
        this.checkForTeam = this.checkForTeam.bind(this)
        this.checkForTools = this.checkForTools.bind(this)
        this.reactiveIdea = this.reactiveIdea.bind(this)
    }
    onSetSidebarOpen(open){
        this.setState({sidebarOpen: open})
        Logger.trackEvent('onSetSidebarOpen', 'open', open)
    }
    componentWillMount(){
        mql.addListener(this.mediaQueryChanged)
        this.setState({mql: mql})
        if (this.state.mql.matches === false){
            this.setState({sidebarOpen: false})
        }
        else {
            this.setState({sidebarOpen: true})
        }
        if (this.state.sidebarOpen !== true && this.state.sidebarOpen !== undefined){
            this.setState({sidebarDocked: mql.matches})
        }
        else {
            this.setState({sidebarDocked: true})
        }
    }
    mediaQueryChanged(){
        this.setState({sidebarDocked: this.state.mql.matches})
        if (this.state.sidebarOpen === false){
            this.setState({sidebarDocked: true})
        }
    }
    componentWillUnmount() {
        this.state.mql.removeListener(this.mediaQueryChanged)
        if (this.unwatchAuth) {
            this.unwatchAuth()
            this.unwatchAuth = null
        }
    }
    statusSymbol(){
        const {stores} = this.props
        const {store} = stores
        if (!store.online)
            return <span className='glyphicon glyphicon-ban-circle' style={{fontSize:20+'px',top:10+'px',left:7.5+'px'}}> </span>
        else if(store.saving && store.online)
            return <span className='glyphicon glyphicon-pencil' style={{fontSize:20+'px',top:10+'px',left:7.5+'px'}}></span>
        else if(store.showSpinner && store.online)
            return <span className='glyphicon glyphicon-refresh Spinner' style={{fontSize:20+'px',top:10+'px',left:7.5+'px'}}></span>
        else if(!store.showSpinner && store.online)
            return <span className='glyphicon glyphicon-ok' style={{fontSize:20+'px',top:10+'px',left:7.5+'px'}}> </span>
        else
            return <span className='glyphicon glyphicon-question-sign' style={{fontSize:20+'px',top:10+'px',left:7.5+'px'}}> </span>
    }
    openTab(link){
        var win = window.open(link, '_blank')
        if (win) {
            //Browser will open a new tab
            win.focus()
        } else {
            //Browser has popups blocked
            alert('Popups on your browser are disabled, re-enable them in order to see the page.')
        }
        Logger.trackEvent('openTab','popupsBlocked',!win)
    }
    doClose() {
        // console.log('doClose')
        const {stores} = this.props
        const {routingStore} = stores
        const {push} = routingStore
        push('/ideas')
    }
    doHideSidebar(){
        this.setState({sidebarOpen:false})
        this.props.stores.prefStore.openSidebar = false
        if (this.state.mql.matches === false){
            this.setState({sidebarDocked: true})
        }
        Logger.trackEvent('doHideSidebar')
    }
    toggleOpen(ev){
        Logger.trackEvent('toggleOpen','sidebarOpen',!this.state.sidebarOpen)
        this.props.stores.prefStore.openSidebar = true
        this.setState({sidebarOpen: !this.state.sidebarOpen})
        if(this.state.mql.matches)
            this.setState({sidebarDocked: true })
        else
            this.setState({sidebarDocked: false })

        if (ev) {
            ev.preventDefault()
        }
    }
    handleDuplicate() {
        const {stores} = this.props
        const {routingStore, store} = stores
        const {push, location} = routingStore
        window.onpopstate = undefined
        let ideaPageMode = '/view'
        if (location.pathname.endsWith('/edit')){
            ideaPageMode = '/edit'
        } else {
            ideaPageMode = '/view'
        }
        this.props.stores.store.duplicateIdea(store.theIdea, this.props.ideaKey).then((newIdeaKey) => {
            push('/idea/'+ newIdeaKey + ideaPageMode)
            store.infoAlert = 'Idea duplicated'
            window.setTimeout(() => {
                store.infoAlert = undefined
            }, 3000)
        })
        Logger.trackEvent('duplicateIdea', 'ideaKey', this.props.ideaKey)
    }
    handleDelete() {
        var ideaKey = this.props.ideaKey
        Logger.trackEvent('deleteIdea', 'ideaKey', ideaKey)
        this.props.stores.store.deleteIdea(ideaKey)
        this.doClose()
    }
    onPresentOptions(e) {
        const { routingStore } = this.props.stores
        const { push } = routingStore
        Logger.trackEvent('presentIdeaOptionsOpened')
        push('/idea/'+ this.props.ideaKey+'/presentation-options')
    }
    onPresentIdea(e) {
        // console.log('present idea')
        const {stores} = this.props
        const {routingStore} = stores
        const { push } = routingStore
        window.onpopstate = undefined
        Logger.trackEvent('presentIdea', 'ideaKey', this.props.ideaKey)
        push('/present/'+this.props.ideaKey+'#/0')
    }
    onViewIdea(e) {
        const {stores} = this.props
        const {routingStore} = stores
        const { push } = routingStore
        window.onpopstate = undefined
        Logger.trackEvent('viewIdea', 'ideaKey', this.props.ideaKey)
        push('/idea/'+this.props.ideaKey+'/view')
    }
    onEditIdea(e) {
        const {stores} = this.props
        const {routingStore} = stores
        const { push } = routingStore
        window.onpopstate = undefined
        Logger.trackEvent('editIdea', 'ideaKey', this.props.ideaKey)
        push('/idea/'+this.props.ideaKey+'/edit')
    }
    checkForDescContent(){
        const {stores} = this.props
        const {store} = stores
        const {theIdea} = store
        if (theIdea !== undefined){
            if (theIdea.hasOwnProperty('description') && theIdea.description){
                return true
            }
            else if (theIdea.hasOwnProperty('imageUrl') && theIdea.imageUrl){
                return true
            }
            else if (theIdea.hasOwnProperty('need') && theIdea.need){
                return true
            }
            else if (theIdea.hasOwnProperty('needImageUrl') && theIdea.needImageUrl){
                return true
            }
            else return false
        }
        else return false
    }
    openStoredIdeas(){
        const {stores} = this.props
        const {routingStore} = stores
        const { push } = routingStore
        push('/idea-storage/')
    }
    checkForDetailsContent(){
        const {stores} = this.props
        const {store} = stores
        const {theIdea} = store
        if (theIdea !== undefined){
            if (theIdea.hasOwnProperty('imageUrls') && theIdea.imageUrls.length > 0){
                return true
            }
            else if (theIdea.hasOwnProperty('imageText') && theIdea.imageText){
                return true
            }
            else if (theIdea.hasOwnProperty('gotSketch') && theIdea.gotSketch){
                return true
            }
            else if (theIdea.hasOwnProperty('sketchText') && theIdea.sketchText){
                return true
            }
            else if (theIdea.hasOwnProperty('attachmentUrls') && theIdea.attachmentUrls.length > 0){
                return true
            }
            else if (theIdea.hasOwnProperty('attachmentText') && theIdea.attachmentText){
                return true
            }
            else if (theIdea.hasOwnProperty('moreDescription') && theIdea.moreDescription && theIdea.moreDescription !== '<p><br></p>'){
                return true
            }
            else return false
        }
        else return false
    }
    checkForStage(){
        const {stores} = this.props
        const {store} = stores
        const {theIdea} = store
        if (theIdea !== undefined){
            if (theIdea.hasOwnProperty('currentStage') && theIdea.currentStage > 0){
                return true
            }
            else return false
        }
        else return false
    }
    checkForRec(){
        const {stores} = this.props
        const {store} = stores
        const {theIdea} = store
        if (theIdea !== undefined){
            if ((theIdea.hasOwnProperty('effortRating') && theIdea.effortRating > 0) && (theIdea.hasOwnProperty('impactRating') && theIdea.impactRating > 0)){
            return true
        }
        else return false
        }
        else return false
    }
    checkForTeam(){
        const {stores} = this.props
        const {store} = stores
        const {theIdea} = store
        if (theIdea !== undefined){
        if (theIdea.hasOwnProperty('team') && theIdea.team.length > 0){
            return true
        }
        else return false
        }
        else return false
    }
    checkForTools(){
        const {stores} = this.props
        const {store, toolStore} = stores
        const {theIdea} = store
        let theTool = null
        if (theIdea !== undefined){
            for (let index in toolStore.toolOrder){
                if (theIdea[toolStore.toolOrder[index]]){
                    theTool = theIdea[toolStore.toolOrder[index]]
                    for (let i in theTool){
                        if (theTool[i] !== '') {
                            return true
                        }
                    }
                }
            }
            if (theIdea.hasOwnProperty('timelineRows') && theIdea.timelineRows.length > 0) {
                return true
            }
            else {
                if (theIdea.hasOwnProperty('costRows') && theIdea.costRows.length > 0) {
                    return true
                }
                if (theIdea.hasOwnProperty('revenueRows') && theIdea.revenueRows.length > 0) {
                    return true
                }
                if (theIdea.hasOwnProperty('viabilityText') && theIdea.viabilityText) {
                    return true
                }
            }
        }
        else return false
    }
    onresize(e) {
        let thing = this
        let width = e.target.outerWidth
        if (width < 1456){
            thing.setState({adjustmentNumber: 71})
        }
        else {
            thing.setState({adjustmentNumber: 74})
        }
    }
    reactiveIdea() {
        const {stores} = this.props
        const {authStore, notificationStore, store} = stores
        const {theIdea} = store

        store.reactivateTheIdea(this.props.ideaKey).then((ideaKey) => {
            store.infoAlert = 'Idea reactivated'
            notificationStore.createNotificationToTeamMembers(ideaKey, authStore.authUser().displayName + ' has reactivated this idea.', theIdea.owner, toJS(theIdea.team), theIdea.responsible, null)
            window.setTimeout(() => {
                store.infoAlert = undefined
            }, 3000)
        })
    }
    render() {
        const {stores} = this.props
        const {store, routingStore, authStore, prefStore} = stores
        const {location} = routingStore
        const authUser = authStore.authUser()
        const {theIdea} = store
        var isOwner = false
        var canPresent = false
        let ideaPageBottomStyling = ''
        let ideaPageListButton = ''
        let ideaButtonStyling = ''
        let boxShadowSetting = "3px 0 0 0px #F0F0F0"
        if(theIdea && authUser){
            isOwner = (authUser.email === theIdea.owner) ? true : false
            if(theIdea.hasOwnProperty('lastUpdated')){
                canPresent = true
            }
            if(theIdea.hasOwnProperty('teamId')){
                authStore.findTeamAdmins(theIdea.teamId, authUser.uid).then((adminFound) => {
                })

            }
        }
        let atOnePager = -1
        // let viewGlyphColor = location.pathname.endsWith('/view')?'#ED1558':'white'
        let viewGlyphColor = 'white'
        // let editGlyphColor = location.pathname.endsWith('/edit')?'#ED1558':'white'
        let backgroundViewGlyphColor = location.pathname.endsWith('/view')?'#ED1558':'#1e1f20'
        let backgroundEditGlyphColor = location.pathname.endsWith('/edit')?'#ED1558':'#1e1f20'
        let editGlyphColor = 'white'
        if ((location.pathname.endsWith('/edit'))){
            atOnePager = 0
            ideaPageBottomStyling = 'sidebarBottomEditIdea'
            ideaButtonStyling = 'editIdeaButtonGlyph'
            ideaPageListButton = 'sidebarListButtonEdit'
        }
        else {
            atOnePager = -1
            ideaPageBottomStyling = 'sidebarBottomViewIdea'
            ideaButtonStyling = 'viewIdeaButtonGlyph'
            ideaPageListButton = 'sidebarListButtonView'
        }
        let presentationOptionsMode = location.pathname.endsWith('/presentation-options')?true:false
        // let presentationGlyphColor = 'white'
        let backButtonText = prefStore.majorMode===majorModes.ideas ? 'Ideas' : 'Progress'
        let pathToList = '/ideas/'
        if (theIdea && theIdea.hasOwnProperty('status')){
            backButtonText = 'Idea storage'
            pathToList = '/idea-storage/'
        }
        let topAdjustment = 0

        window.addEventListener("resize", this.onresize)

        var w = window.innerWidth
        if (!this.state.adjustmentNumber){
            if (w < 1456){
                topAdjustment = 71
            }
            else topAdjustment = 74
        }
        else {
            topAdjustment = this.state.adjustmentNumber
        }

        let canView = false

        if (theIdea){
            canView = store.isPartOfTheIdea(theIdea, authUser)
        }
        let sidebarContent = null
        let sidebarWidth = 0

        const presentBrowserHandler = {
            ie: () =>   <ToolTip tipText='This browser does not support presentation mode. We highly suggest using Google Chrome.'>
                            <div className='IdeaPageSideBarIcon'>
                                <h3>
                                <img alt='boar-3-white' style={{width: 18+'px', height: 28+'px', paddingTop: 8+'px'}} src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAABCCAYAAAAPIWX+AAAACXBIWXMAAAsSAAALEgHS3X78AAAB50lEQVR4Ae2b323CMBCHf5wqtW/lra/pBhkBNmCDMgIjtBvQDegGdAPYgE7QskE6gO3KgfDXCUU4iZ27T4qEItu5L3KCdTn3jDE4Qus+gCmAEYBHxM0vgFnuQ/RzaOIStw1fIhc+ZQ0gBVFWnHeJm+oxomUIokURPHVU8iIizg0R54aIc0PEuSHi3BBxbog4N0ScGyLODRHnhohzQ8S5IeLcEHFuiDg3OInvigJQIv7eYDBNsQTR6vBa5xURyKsi0m0NTBdYgWh+6uEWZwDbl9vd7pfWrwAGrUZTP7bka2KrnzZTvZslXmV8gSjtGaUSAN9hxlgbQ/uMJx2VqyIppnrWgfLNa3gu3uqTOOL1wputa93/j2udbBct/RtHfwAwBvBU0WYJYHHQ3t74+4r2n/lC5HbmuxWcFfd2KNU3Sq2MUqbimJ1dT6nUKJVd6Df2GWv70i3JhyHdgnw40g3LhyXdoHx40g3JhyndgHy40jXLhy1do3z40jXJxyFdg3w80p7l45L2KB+ftCf5OKU9yJcNOAle+v/ymatfWV69KhnxAaKxh6SAHzaJhcF257ALZ0qtTDwrOR+WdEG1/NrZ54pnfBrM9L5u2o9cbau/nWltc3D2A+I+VxU6m43/Re7Qxn20YT4HwB+Kk7wgQExoTgAAAABJRU5ErkJggg=='/>
                                    {/* <Glyphicon glyph='expand' style={{color: presentationGlyphColor, paddingTop: 6+'px', paddingLeft: 3+'px'}}/> */}
                                    </h3>
                            </div>
                        </ToolTip>,
            default: () =>
            <div onClick={this.onPresentIdea.bind(this)} className='IdeaPageSideBarIcon'>
                <h3>
                    <ToolTip tipText='Present idea'>
                    <img alt='boar-3-white' style={{width: 18+'px', height: 28+'px', paddingTop: 8+'px'}} src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAABCCAYAAAAPIWX+AAAACXBIWXMAAAsSAAALEgHS3X78AAAB50lEQVR4Ae2b323CMBCHf5wqtW/lra/pBhkBNmCDMgIjtBvQDegGdAPYgE7QskE6gO3KgfDXCUU4iZ27T4qEItu5L3KCdTn3jDE4Qus+gCmAEYBHxM0vgFnuQ/RzaOIStw1fIhc+ZQ0gBVFWnHeJm+oxomUIokURPHVU8iIizg0R54aIc0PEuSHi3BBxbog4N0ScGyLODRHnhohzQ8S5IeLcEHFuiDg3OInvigJQIv7eYDBNsQTR6vBa5xURyKsi0m0NTBdYgWh+6uEWZwDbl9vd7pfWrwAGrUZTP7bka2KrnzZTvZslXmV8gSjtGaUSAN9hxlgbQ/uMJx2VqyIppnrWgfLNa3gu3uqTOOL1wputa93/j2udbBct/RtHfwAwBvBU0WYJYHHQ3t74+4r2n/lC5HbmuxWcFfd2KNU3Sq2MUqbimJ1dT6nUKJVd6Df2GWv70i3JhyHdgnw40g3LhyXdoHx40g3JhyndgHy40jXLhy1do3z40jXJxyFdg3w80p7l45L2KB+ftCf5OKU9yJcNOAle+v/ymatfWV69KhnxAaKxh6SAHzaJhcF257ALZ0qtTDwrOR+WdEG1/NrZ54pnfBrM9L5u2o9cbau/nWltc3D2A+I+VxU6m43/Re7Qxn20YT4HwB+Kk7wgQExoTgAAAABJRU5ErkJggg=='/>
                    {/*     <Glyphicon glyph='expand' style={{cursor: 'pointer', color: presentationGlyphColor, paddingTop: 6+'px', paddingLeft: 3+'px'}} onClick={this.onPresentIdea.bind(this)}/> */}
                    </ToolTip>
                </h3>
            </div>,
        }

        if(prefStore.openSidebar === false){
            sidebarContent =
                <div style={{position: 'absolute',zIndex:800,left: 0+'px',top: 0+'px',height: 100+'%',width:25+'px',backgroundColor: 'white'}} >
                    <Button
                        style={{position: 'fixed',paddingLeft: 3+'px',zIndex:900,height: 100+'%',width:25+'px',outline: 0,backgroundColor: 'white'}}
                        bsStyle='link'
                        onClick={this.toggleOpen}
                    >
                        <h5><Glyphicon glyph='menu-right'/></h5>
                    </Button>
                </div>
            sidebarWidth = 25
        }
        else {
            sidebarContent =
                <div>
                    <br/>
                    {!presentationOptionsMode &&
                        <div>
                            <Link to={{ pathname: pathToList }} style={{color: '#1e1f20 '}} activeStyle={{ textDecoration: 'underline' }}>
                                <h4 className='sidebarContent'><Glyphicon glyph='circle-arrow-left' className='sidebarIdeaPageIcons' style={{color: '#1e1f20'}}/>{backButtonText}</h4>
                            </Link>
                        </div>
                    }
                    {presentationOptionsMode &&
                        <div>
                        <div className='presentatinoBackBtn' onClick={() => {browserHistory.goBack()}} style={{color: '#1e1f20 '}}>
                            <h4 className='sidebarContent'><Glyphicon glyph='circle-arrow-left' className='sidebarIdeaPageIcons' style={{color: '#1e1f20'}}/>{'Back to the idea'}</h4>
                        </div>
                    </div>
                    }
                    {theIdea && !theIdea.hasOwnProperty('status') &&
                        <hr className='sidebarDivider' style={{marginBottom: 8+'px'}}/>
                    }
                    <Row className='sidebarIdeaPageControl'>
                        {theIdea && !theIdea.hasOwnProperty('status') &&
                            <Col xs={4}>
                                {canPresent &&
                                 <div onClick={this.onViewIdea} className='IdeaPageSideBarIcon' style={{backgroundColor: backgroundViewGlyphColor}}>
                                    <h3><ToolTip tipText='View idea'><Glyphicon glyph='eye-open' style={{cursor: 'pointer', color: viewGlyphColor, paddingTop: 10+'px', paddingLeft: 0+'px', fontSize: 20+'px'}}/></ToolTip></h3>
                                 </div>
                                }
                            </Col>
                        }
                        {canView === true &&
                            <div>
                                {theIdea && !theIdea.hasOwnProperty('status') &&
                                    <Col xs={4}>
                                        <div onClick={this.onEditIdea} className='IdeaPageSideBarIcon' style={{backgroundColor: backgroundEditGlyphColor}}>
                                            <h3><ToolTip tipText='Edit idea'><Glyphicon glyph='pencil' style={{cursor: 'pointer', color: editGlyphColor, paddingTop: 10+'px', paddingLeft: 0+'px', fontSize: 20+'px'}}/></ToolTip></h3>
                                        </div>
                                    </Col>
                                }
                            </div>
                        }
                        {theIdea && !theIdea.hasOwnProperty('status') &&
                            <Col xs={4} style={{zIndex: 900}}>
                                {canPresent &&
                                    <BrowserDetection>
                                        { presentBrowserHandler }
                                    </BrowserDetection>
                                }
                            </Col>
                        }
                    </Row>
                    {presentationOptionsMode === false &&
                        <hr className='sidebarDivider'/>
                    }
                    {!presentationOptionsMode &&
                    <div>
                        {atOnePager !== -1 &&
                            <div>
                                <div className='sidebarContent'>
                                    <p><a style={{cursor: 'pointer', color: '#1e1f20'}} onClick={()=> document.getElementById('ideaDescription').scrollIntoView() }>1. Description</a>
                                    {this.checkForDescContent() &&
                                        <Glyphicon glyph='ok' className='contentIndicatorSidebar'/>
                                    }</p>
                                    <p><a style={{cursor: 'pointer', color: '#1e1f20'}} onClick={()=> document.getElementById('ideaAddDetails').scrollIntoView() }>2. Details</a>
                                    {this.checkForDetailsContent() &&
                                        <Glyphicon glyph='ok' className='contentIndicatorSidebar'/>
                                    }
                                    </p>
                                    <p><a style={{cursor: 'pointer', color: '#1e1f20'}} onClick={()=> document.getElementById('ideaStage').scrollIntoView() }>3. Stage</a>
                                    {this.checkForStage() &&
                                        <Glyphicon glyph='ok' className='contentIndicatorSidebar'/>
                                    }
                                    </p>
                                    <p><a style={{cursor: 'pointer', color: '#1e1f20'}} onClick={()=> document.getElementById('ideaRating').scrollIntoView() }>4. Rating</a>
                                    {this.checkForRec() &&
                                        <Glyphicon glyph='ok' className='contentIndicatorSidebar'/>
                                    }
                                    </p>
                                    <p><a style={{cursor: 'pointer', color: '#1e1f20'}} onClick={()=> document.getElementById('ideaCollaboration').scrollIntoView() }>5. Collaboration</a>
                                    {this.checkForTeam() &&
                                        <Glyphicon glyph='ok' className='contentIndicatorSidebar'/>
                                    }
                                    </p>
                                    <p><a style={{cursor: 'pointer', color: '#1e1f20'}} onClick={()=> document.getElementById('ideaTools').scrollIntoView() }>6. Strengthen your idea</a>
                                    {this.checkForTools() &&
                                        <Glyphicon glyph='ok' className='contentIndicatorSidebar'/>
                                    }
                                    </p>
                                </div>
                                <hr className='sidebarDivider'/>
                            </div>
                        }
                        <div className='ideaPageSelectorContainer'>
                            {theIdea && !theIdea.hasOwnProperty('status') &&
                                <Button style={{color: '#1e1f20'}} bsStyle='link' onClick={this.onPresentOptions}><Glyphicon className='sidebarIdeaPageIcons' glyph='cog' style={{color: '#1e1f20'}} />Presentation Options</Button>
                            }
                            {theIdea && theIdea.hasOwnProperty('status') &&
                                <Button style={{color: '#1e1f20'}} bsStyle='link' onClick={() => this.reactiveIdea()}><Glyphicon className='sidebarReactivateIcon' glyph='transfer' style={{color: '#1e1f20'}}/>Reactivate idea</Button>
                            }
                            {(isOwner || authStore.auth.isTeamAdmin === true || (theIdea !== undefined && authUser && theIdea.hasOwnProperty('responsible') && theIdea.responsible.userId === authUser.uid)) &&
                                <Confirm
                                    onConfirm={this.handleDuplicate}
                                    body='Are you sure you want to duplicate this idea?'
                                    confirmText='Confirm Duplicate'
                                    title='Duplicating Idea'
                                    style={{color: '#1e1f20'}}
                                    >
                                    <Button bsStyle='link'><Glyphicon className='sidebarIdeaPageIcons' glyph='duplicate' style={{color: '#1e1f20'}}/>Duplicate Idea</Button>
                                </Confirm>
                            }
                            {(isOwner || authStore.auth.isTeamAdmin === true || (theIdea !== undefined && authUser && theIdea.hasOwnProperty('responsible') && theIdea.responsible.userId === authUser.uid)) &&
                                <Confirm
                                    onConfirm={this.handleDelete}
                                    body='Are you sure you want to delete this idea?'
                                    confirmText='Confirm Delete'
                                    title='Deleting Idea'
                                    style={{color: '#1e1f20'}}>
                                    <Button bsStyle='link'><Glyphicon className='sidebarIdeaPageIcons' glyph='trash' style={{color: '#1e1f20'}}/>Delete Idea</Button>
                                </Confirm>
                            }
                        </div>
                    </div>
                    }
                    <div className='ideaPageSidebarFooterContainer'>
                        {theIdea && !theIdea.hasOwnProperty('status') &&
                            <div>
                                <hr className='sidebarDivider'/>
                                <div className='sidebarFooter'>
                                    <p className='sidebarLink'><Glyphicon glyph='hdd' className='sidebarIdeaPageBottomIcons'/><a style={{cursor: 'pointer', color: '#9b9b9b'}} onClick={()=> this.openStoredIdeas()}>Stored ideas</a></p>
                                    <p className='sidebarLink'><Glyphicon glyph='facetime-video' className='sidebarIdeaPageBottomIcons'/><a style={{cursor: 'pointer', color: '#9b9b9b'}} onClick={()=> this.openTab('https://pre.do/how-to-videos/?lang=en')}>How-To Videos</a></p>
                                    <p className='sidebarLink'><Glyphicon glyph='envelope' className='sidebarIdeaPageBottomIcons'/><a style={{cursor: 'pointer', color: '#9b9b9b'}} onClick={()=> this.openTab('https://pre.do/blog/')}>Blog</a></p>
                                    <p className='sidebarLink'><Glyphicon glyph='check' className='sidebarIdeaPageBottomIcons'/><a style={{cursor: 'pointer', color: '#9b9b9b'}} onClick={()=> this.openTab('https://pre.do/handelsbetingelser/')}>Terms</a></p>
                                    <p className='sidebarLink'><Glyphicon glyph='lock' className='sidebarIdeaPageBottomIcons'/><a style={{cursor: 'pointer', color: '#9b9b9b'}} onClick={()=> this.openTab('https://pre.do/security-policy/')}>Security</a></p>
                                </div>
                                <div className={ideaPageBottomStyling}><a style={{cursor: 'pointer', color: '#9b9b9b'}} onClick={()=> this.openTab('https://pre.do')}>© 2019 PRE.DO</a></div>
                            </div>
                        }
                    </div>
                    {(this.state.sidebarDocked || this.state.sidebarOpen) && (
                        <div className='ideaPageSidebarButtonContainer' style={{position: 'absolute',zIndex:800,top: 0+'px',width:25+'px',backgroundColor: 'white'}} >
                        <Button
                            style={{position: 'fixed',zIndex:900,width:25+'px',height: 100+'%',outline: 0,backgroundColor: 'white'}}
                            bsStyle='link'
                            onClick={this.doHideSidebar}
                            className={ideaPageListButton}
                        >
                            <h5><Glyphicon className={ideaButtonStyling} glyph='menu-left' style={{color: '#ed1558'}}/></h5>
                        </Button>
                        </div>
                    )}
                </div>
            sidebarWidth = 250
        }

        const sidebarStyles = {
            root: {
                position: 'absolute',
                top: topAdjustment+'px',
            },
            sidebar: {
                backgroundColor: 'white',
                color: '#1e1f20 ',
                width: sidebarWidth+'px',
                zIndex: 990,
                top: 0,
                overflowX: 'hidden',
                boxShadow: boxShadowSetting,
            },
            content: {
                top: 0,
            },
            overlay: {
                zIndex: 900,
            },
        }

        return (
            <Sidebar
                sidebar={sidebarContent}
                styles={sidebarStyles}
                transitions={false}
                shadow={false}
                open={true}
                touch={false}
                docked={this.state.sidebarDocked}
                onSetOpen={this.onSetSidebarOpen}
            >
                <div className='ideaListChildrenContainer' style={{position: 'relative'}}>
                    {this.props.children}
                </div>
            </Sidebar>
        )
    }
}
IdeaPageSidebar.propTypes = {
    ideaKey: PropTypes.string,
}

export default inject("stores")(observer(IdeaPageSidebar))



// WEBPACK FOOTER //
// ./src/containers/IdeaPageSidebar.js